import React, { useRef, useEffect } from "react";
import "./ProfilePopup.css";
import exit from "../../assets/images/exit.png";
import { useNavigate } from "react-router-dom";

const ProfilePopup = (show) => {
  const ssEmailRef = useRef(null);
  const ssNameRef = useRef(null);
  useEffect(() => {
    try {
      const rawEmail = sessionStorage.getItem("login_email");
      const rawName = sessionStorage.getItem("login_name");
      const email = rawEmail ? rawEmail.trim().toLowerCase() : null;
      const name = rawName ? rawName.trim() : null;
      ssEmailRef.current = email; // do NOT fall back to userIdentity
      ssNameRef.current = name;
    } catch {}
  }, []);
  const navigate = useNavigate();
  const logout = () => {
    navigate("/");
  };
  return (
    <div className={`popup-card ${show ? "show" : ""}`}>
      <div className="popup-header">{ssNameRef.current}</div>
      <div className="popup-body">
        <p>{ssEmailRef.current}</p>
        <button className="logout-button" onClick={logout}>
          <div className="flex fdir-row fhor-center">
            LOG OUT
            <img src={exit} alt="Log out" />
          </div>
        </button>
      </div>
    </div>
  );
};

export default ProfilePopup;
